<script lang="ts">
  import type { Teaser, ImageWithMeta } from "$lib/types/shared";
  import Card from "$lib/Card.svelte";
  import AppDownloadButtons from "$lib/AppDownloadButtons.svelte";

  const intersectionObserverAction = (element: HTMLElement) => {
    const observer = new IntersectionObserver(async (entries) => {
      if (entries[0].isIntersecting) {
        observer.disconnect();

        if (fetchData && !(title && description && image))
          fetchedContent = await fetch("/api/privat/app/teaser").then((res) => res.json());
      }
    });

    observer.observe(element);
  };

  

  interface Props {
    title?: string;
    description?: string;
    image?: ImageWithMeta | null;
    href?: string | null;
    circleImage?: boolean;
    lang?: string;
    fetchData?: boolean;
    class?: string;
  }

  let {
    title = "",
    description = "",
    image = null,
    href = null,
    circleImage = false,
    lang = "",
    fetchData = true,
    class: classes = ""
  }: Props = $props();
  let fetchedContent: Teaser = $state();
</script>

<svelte:element
  this={title || fetchedContent?.title ? "section" : "div"}
  use:intersectionObserverAction
  class={classes}
  lang={lang ? lang : undefined}
>
  <Card
    size="full"
    pictureObject={image || fetchedContent?.image}
    {circleImage}
    {href}
    --card-picture-aspect-ratio="unset"
  >
    {#if title || fetchedContent?.title}
      <h2 class="mb-2">{title || fetchedContent.title}</h2>
    {/if}

    {#if description || fetchedContent?.description}
      <p class="mt-2">{description || fetchedContent.description}</p>
    {/if}

    <AppDownloadButtons />
  </Card>
</svelte:element>

<style lang="postcss">
  section {
    margin-inline: var(--space-edge-x);
    min-height: 15rem;
  }
</style>
